import { apiClient } from '@devd-client/api';
import { getToken, getOrgId } from '@devd-client/devd/auth';

export const getMetricPages = (pageName: string): Promise<any> =>
  apiClient(`/v2/account/org/${getOrgId()}/page/${pageName}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
